/** The locale to use for number formatting. */
const locale = 'en-US';

/** Converts the passed value to a number.*/
const getRawNumber = (value: string | number): number => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  const stringValue = String(value).trim();

  // Remove any characters that aren't a number or period.
  const strippedValue = stringValue.replace(/[^\d.]/g, '');

  // Ensure that we can work with negative numbers.
  const sign = stringValue.startsWith('-') ? '-' : '';

  return Number(`${sign}${strippedValue}`) || 0;
};

/** Format a number as USD currency. */
export const formatCurrency = (
  amount: string | number,
  showCents = false,
): string => {
  const rawNum: number = getRawNumber(amount);
  const decimalPlaces = showCents ? 2 : 0;
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  };

  return rawNum.toLocaleString(locale, options);
};
